var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Reset zone ")]
          ),
          _c("gg-card-text", [
            _c(
              "p",
              {
                staticClass: "mb-2"
              },
              [
                _vm._v(
                  " Resetting your zone file will erase any modifications you have made to your zone records. The system will attempt to preserve TXT records. However, we recommend that you take note of any records you want to save. "
                )
              ]
            ),
            _c(
              "p",
              {
                staticClass: "mb-0"
              },
              [
                _vm._v(
                  " Are you sure you want to erase all entries and revert to the default state? "
                )
              ]
            )
          ]),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.resetZone
                  }
                },
                [_vm._v("Reset")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }